// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"PendingChanges_buttonContainer__2taCe"};